import { useMemo } from "react";
import { useSite } from "../SiteProvider";
const useRepeatableRepeaterProps = (props, limit = -1) => {
    const { repeatables } = useSite();
    const selectedRepeatable = useMemo(() => repeatables?.find((r) => r.id.toString() === props?.repeatable?.toString()), [props?.repeatable, repeatables]);
    const items = useMemo(() => {
        let items = selectedRepeatable?.items || [];
        // Apply filters
        if (props?.filters) {
            items = items.filter((item) => {
                return props.filters.every((filter) => {
                    const field = selectedRepeatable?.fields?.find((field) => field.identifier === filter?.fieldIdentifier);
                    const valueIndex = item.values.findIndex((value) => value.field_id === field?.id);
                    if (filter?.fieldOption === "off") {
                        if (valueIndex === -1)
                            return true;
                        return item.values[valueIndex]?.value !== "on";
                    }
                    if (filter?.fieldOption === "not-equal") {
                        return item.values[valueIndex]?.value !== filter?.fieldOptionValue;
                    }
                    if (filter?.fieldOptionValue) {
                        return item.values[valueIndex]?.value === filter?.fieldOptionValue;
                    }
                    return item.values[valueIndex]?.value === filter?.fieldOption;
                });
            });
        }
        // Apply sorts
        if (props?.sorts) {
            items = items.sort((a, b) => {
                return props.sorts.reduce((acc, sort) => {
                    const field = selectedRepeatable?.fields?.find((field) => field.identifier === sort?.fieldIdentifier);
                    const aValueIndex = a.values.findIndex((value) => value.field_id === field?.id);
                    const bValueIndex = b.values.findIndex((value) => value.field_id === field?.id);
                    if (sort?.fieldOption === "asc") {
                        return acc ||
                            a.values[aValueIndex]?.value > b.values[bValueIndex]?.value
                            ? 1
                            : -1;
                    }
                    return acc ||
                        a.values[aValueIndex]?.value < b.values[bValueIndex]?.value
                        ? 1
                        : -1;
                }, 0);
            });
        }
        return items.slice(0, limit);
    }, [selectedRepeatable, props?.filters, props?.sorts]);
    return {
        props: {
            "editor-repeatable-repeater": props?.repeatable,
            "editor-repeatable-repeater-filters": props?.filters && JSON.stringify(props?.filters),
            "editor-repeatable-repeater-sorts": props?.sorts && JSON.stringify(props?.sorts),
        },
        repeatable: selectedRepeatable,
        items,
    };
};
export default useRepeatableRepeaterProps;
//# sourceMappingURL=useRepeatableRepeaterProps.js.map